module.exports = __webpack_public_path__ + "img/2-1_05.9d618a12.jpg";